import {APIPlatformSerializer} from './abstract';
import {PROVIDER} from '../../../resources';
import {DocumentTypeSerializer} from './DocumentTypeSerializer';

export class DocumentSerializer extends APIPlatformSerializer {
  base = PROVIDER.DOCUMENTS;

  serialize(data) {
    this.filename = data.filename;
    this.documentType = new DocumentTypeSerializer().getIRI(data.documentType);
    this.companyId = data.company?.id || data.company;
    this.createdAt = data.createdAt;
    if (!data.id) this.file = data.file || '';
  }
}
